import React from "react";
import ReactDOM from "react-dom";
import App from "./routes/App.js";
import reportWebVitals from "./reportWebVitals";
import "./index.css";

// creando un store con redux
// compose, espara la extension de chrome
import { createStore, compose, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import reducer from "./reducers/index";
import thunk from "redux-thunk";

const initialState = {
  user: {
    email: "",
    name: "",
    id: ""
  },
  playing: {},
  myList: [],
  trends: [],
  originals: []
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  reducer,
  initialState,
  composeEnhancers(applyMiddleware(thunk))
);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
